'use client'

import { useRouter } from 'next/router';
import styles from './loggedOutLayout.module.css'
import en from '@/locales/en/commonLoggedOutContent';
import ar from '@/locales/ar/commonLoggedOutContent';
import { MenuItem, TextField } from '@mui/material';
import { FORGOT_PASSWORD_PATH, LOGIN_PATH, OTP_PATH, REGISTRATION_PATH, SET_PASSWORD_PATH } from '@/config/constants';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import DownloadAppOverlay from '@/components/DownloadApp/DownloadAppOverlay/downloadAppOverlay';

export type CommonLayoutProps = {
    children: React.ReactNode;
    showDownloadPopUp?: Boolean 
};
export default function LoggedOutLayout({ children, showDownloadPopUp }: CommonLayoutProps) {
    const user = useSelector((state: any) => {
        return { ...state.user }
    })
    const router = useRouter();
    const goToRegisterScreen = (e: any) => {
        e.preventDefault()
        router.push(REGISTRATION_PATH);
    }
    const goToLoginScreen = (e: any) => {
        e.preventDefault()
        if (router?.query?.recordId) {
          router.push(`${LOGIN_PATH}?recordId=${router.query.recordId}`);
        } else {
          router.push(LOGIN_PATH);
        }
    }
    const { locale } = router;
    const t: any = locale == 'en' ? en : ar;
    const toggleLanguage = async (e: any) => {
        const localeTemp: any = locale === "en" ? "ar" : "en";

        router.push(router.asPath, router.asPath, { locale: localeTemp })
    }
    return (
        <>
            {showDownloadPopUp && <DownloadAppOverlay/>}
            <div className={`${styles.LoggedOutContainer} LoggedOutContainer ${locale === 'ar' ? styles.ar : styles.en} ${locale === 'ar' ? 'loggedOutContainerAr' : 'loggedOutContainerEn'}`}>

                <div className={styles.registerBtns}>
                    {router.asPath.split('?')[0] == LOGIN_PATH && <button onClick={goToRegisterScreen}>{t['register_button_text']}</button>}
                    {[REGISTRATION_PATH, FORGOT_PASSWORD_PATH, OTP_PATH, SET_PASSWORD_PATH].indexOf(router.asPath.split('?')[0]) != -1 && <button onClick={goToLoginScreen}>{t['login_button_text']}</button>}

                    <div
                        className={`${styles.language_selection}`}
                        key={`language_selection`}
                        defaultValue={locale}
                        onClick={toggleLanguage}

                    >
                        {locale !== "ar" ? "العربية" : "English"}

                    </div>
                </div>
                <div className={styles.overlayPortion}>

                    <div className={styles.overlay_inner_portion}>
                        {children}
                    </div>
                </div>
                <div className={`${styles.footer} loggedOutfooter`} id = "loggedOutfooter">
                    
                    {locale === "en" && <>
                    <u><a href="https://www.aldar.com/en/privacy-policy" target="_blank">{t['privacy_policy']}</a></u>&nbsp;
                        {t['footerText']}<br />{t['footerTextSecondLine']}
                    </>}
                    {locale === "ar" && <>
                        
                        {t['footerText']} <u dir="rtl"><a href="https://www.aldar.com/en/privacy-policy" target="_blank">{t['privacy_policy']}</a></u>&nbsp;<br />{t['footerTextSecondLine']}
                    </>}
                </div>
            </div>
        </>
    );
}
